export const NO_GENDER = 'NoGender';
export const NO_SIZE = 'NoSize';
export const SIZES_ORDER = ['S', 'M', 'L', 'XL'];
export const GENDERS_ORDER = ['Man', 'Woman'];
